<template lang="pug">
	.charts-iface
		.charts(v-for='(chartItem, i) in chart' :key='i')
			chartContainer.chart-section(:style="{ height: height + 'vh' }" :left='chartItem.left' :right='chartItem.right' :header='chartItem.header' :headLabel='chartItem.title' :headDescription='chartItem.subtitle' :footer='chartItem.footer' :chartSelects='chartItem.chartSelects' :barDims='chartItem.barDims', :barType='chartItem.barType' :id='chartItem.id' :legendData='m_legendData(chartItem)' :legendType='m_legendType(chartItem)' :leftLabel="chartItem.leftLabel")
</template>

<style lang="scss" scoped>
.charts-iface {
	margin: 6vh 1vh 0 1vh;
	height: 58vh;
	overflow-x: hidden;
	overflow-y: auto;
	scrollbar-width: none;
	&::-webkit-scrollbar-track {
		background-color: #F5F5F5;
	}
	&::-webkit-scrollbar {
		width: 8px;
		height: 8px;
		background-color: #F5F5F5;
	}
	&::-webkit-scrollbar-thumb {
		border-radius: 10px;
		background-color: #026A44;
		background-clip: content-box;
	}
		.chart-section {
			margin: 1vh 0 1vh 0;
		}
}
</style>

<script>
import chartContainer from '@/components/charts/chartContainer';

export default {
	name       : 'chartsIface',
	components : { chartContainer },
	props : {
		chart: {
			type: Array
		},
		height: {
			type: Number,
			default: 55,
		}
	},
	data : () => ( {

	} ),
	computed : {
		entitySummaryData() {
			return this.$store.getters.entitySummaryData;
		},
		fieldSummaryData() {
			return this.$store.getters.fieldSummaryData;
		},
		varietySummaryData() {
			return this.$store.getters.varietySummaryData;
		},
		paymentScheduleData() {
			return this.$store.getters.paymentScheduleData;
		},
		yearsAvailable() {
			return this.$store.getters.getRearsAvailable;
		},
	},

	methods : {
		m_legendData(item) {
			console.log(item);
			if('legend' in item && 'length' in item.legend) {
				return item.legend;
			}
			return [];
		},
		m_legendType(item) {
			if('legendType' in item) {
				return item.legendType;
			}
			return null;
		}
	},
	created() {
		// console.log('created chartsIface');
		// console.log(this.chart);
		// console.log('chartItem data');

		/*
		// console.log(this.entitySummaryData);
		// console.log(this.fieldSummaryData);
		// console.log(this.varietySummaryData);
		// console.log(this.paymentScheduleData);
		// console.log(this.yearsAvailable);
		*/
	},

	mounted() {
	},

	watch : {
	},

};
</script>
